export const MessageConst = {
    fieldRequired: ' талбарын утга хоосон байна.',
    generalFieldRequired: 'Заавал бөглөх талбарын утга хоосон байна.',
    success: 'Амжилттай'
};